/**
 * Pyth Hermes price feed IDs for the CryptoRace coin pool.
 * Mirrors RACE_COIN_POOL from partyserver/src/heartbeat/tick.ts.
 */

export interface PythFeedEntry {
  id: string;
  symbol: string;
  name: string;
  imageUrl: string;
  feedId: string;
}

export const RACE_COIN_POOL: PythFeedEntry[] = [
  {
    id: 'btc',
    symbol: 'BTC',
    name: 'Bitcoin',
    imageUrl: 'https://assets.coingecko.com/coins/images/1/large/bitcoin.png',
    feedId: '0xe62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43',
  },
  {
    id: 'eth',
    symbol: 'ETH',
    name: 'Ethereum',
    imageUrl: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png',
    feedId: '0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace',
  },
  {
    id: 'sol',
    symbol: 'SOL',
    name: 'Solana',
    imageUrl: 'https://assets.coingecko.com/coins/images/4128/large/solana.png',
    feedId: '0xef0d8b6fda2ceba41da15d4095d1da392a0d2f8ed0c6c7bc0f4cfac8c280b56d',
  },
  {
    id: 'bnb',
    symbol: 'BNB',
    name: 'BNB',
    imageUrl: 'https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png',
    feedId: '0x2f95862b045670cd22bee3114c39763a4a08beeb663b145d283c31d7d1101c4f',
  },
  {
    id: 'xrp',
    symbol: 'XRP',
    name: 'XRP',
    imageUrl: 'https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png',
    feedId: '0xec5d399846a9209f3fe5881d70aae9268c94339ff9817e8d18ff19fa05eea1c8',
  },
  {
    id: 'doge',
    symbol: 'DOGE',
    name: 'Dogecoin',
    imageUrl: 'https://assets.coingecko.com/coins/images/5/large/dogecoin.png',
    feedId: '0xdcef50dd0a4cd2dcc17e45df1676dcb336a11a61c69df7a0299b0150c672d25c',
  },
  {
    id: 'ondo',
    symbol: 'ONDO',
    name: 'Ondo Finance',
    imageUrl: 'https://coin-images.coingecko.com/coins/images/26580/large/ONDO.png',
    feedId: '0xd40472610abe56d36d065a0cf889fc8f1dd9f3b7f2a478231a5fc6df07ea5ce3',
  },
  {
    id: 'hype',
    symbol: 'HYPE',
    name: 'Hyperliquid',
    imageUrl: 'https://coin-images.coingecko.com/coins/images/50882/large/hyperliquid.jpg?1729431300',
    feedId: '0x4279e31cc369bbcc2faf022b382b080e32a8e689ff20fbc530d2a603eb6cd98b',
  },
  {
    id: 'sui',
    symbol: 'SUI',
    name: 'Sui',
    imageUrl: 'https://coin-images.coingecko.com/coins/images/26375/large/sui-ocean-square.png',
    feedId: '0x23d7315113f5b1d3ba7a83604c44b94d79f4fd69af77f804fc7f920a6dc65744',
  },
  {
    id: 'zec',
    symbol: 'ZEC',
    name: 'Zcash',
    imageUrl: 'https://coin-images.coingecko.com/coins/images/486/large/circle-zcash-color.png',
    feedId: '0xbe9b59d178f0d6a97ab4c343bff2aa69caa1eaae3e9048a65788c529b125bb24',
  },
  {
    id: 'ton',
    symbol: 'TON',
    name: 'Toncoin',
    imageUrl: 'https://coin-images.coingecko.com/coins/images/17980/large/photo_2024-09-10_17.09.00.jpeg',
    feedId: '0x8963217838ab4cf5cadc172203c1f0b763fbaa45f346d8ee50ba994bbcac3026',
  },
];

/** Map from coinId → feedId for quick lookups */
export const COIN_ID_TO_FEED_ID: Record<string, string> = Object.fromEntries(
  RACE_COIN_POOL.map((c) => [c.id, c.feedId])
);

/** Map from feedId (normalized, with 0x prefix) → coinId for parsing Pyth responses */
export const FEED_ID_TO_COIN_ID: Record<string, string> = Object.fromEntries(
  RACE_COIN_POOL.map((c) => [c.feedId, c.id])
);
